export enum DocumentStatusEnum {
    waiting = 'waiting',
    checking = 'checking',
    checked = 'checked',
    sent = 'sent',
    denied = 'denied',
    done = 'done',
    sendOriginals = 'sendOriginal',
    transferedToBank = 'transferedToBank',
    approved = 'approved',
}

export const DOCUMENTS_STATUSES_ORDER = [
    DocumentStatusEnum.denied,
    DocumentStatusEnum.sendOriginals,
    DocumentStatusEnum.waiting,
    DocumentStatusEnum.checking,
    DocumentStatusEnum.checked,
    DocumentStatusEnum.approved,
    DocumentStatusEnum.transferedToBank,
    DocumentStatusEnum.done,
];
